import { handleActions } from 'redux-actions';
import { InspectionRsRepair } from 'entities/InspectionRsRepair';
import { SearchRepair } from 'entities/SearchRepair';
import { Repair } from 'entities/Repair';
import { createSimpleHandler } from 'store/utils/createSimpleHandler';
import {
  getAllInspectionRsRepairs,
  getAllRepairs,
  searchRepairs,
  setCustomRequestSearchString,
  setSelectedRepair,
} from './actions';
import createAPIHandlers from '../utils/createAPIHandler';

export interface IRepairsStoreState {
  searchedRepairs: {
    data: { results: SearchRepair[] };
    requesting: boolean;
    errors: any[];
  };
  allRsRepairs: {
    data: InspectionRsRepair[];
    requesting: boolean;
    errors: any[];
  };
  allRepairs: { data: Repair[]; requesting: boolean; errors: any[] };
  customRequestSearch: string;
  selectedRepair?: { repairId: number; name: string };
}

const defaultState: IRepairsStoreState = {
  searchedRepairs: { data: { results: [] }, requesting: false, errors: [] },
  allRsRepairs: { data: [], requesting: false, errors: [] },
  allRepairs: { data: [], requesting: false, errors: [] },
  customRequestSearch: '',
  selectedRepair: undefined,
};

const reducer = handleActions<IRepairsStoreState, any>(
  {
    ...createAPIHandlers(searchRepairs, 'searchedRepairs'),
    ...createAPIHandlers(
      getAllInspectionRsRepairs,
      'allRsRepairs',
      'data.inspectionRsRepairs'
    ),
    ...createAPIHandlers(getAllRepairs, 'allRepairs'),
    [setCustomRequestSearchString.type]: createSimpleHandler(
      'customRequestSearch'
    ),
    [setSelectedRepair.type]: createSimpleHandler('selectedRepair'),
  },
  defaultState
);

export default reducer;
